<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [style]="{width: '840px'}"
  styleClass="p-fluid storico-contributi-dialog"
  [showHeader]="false"
  (onHide)="hide()">

  <div class="dialog-container">
    <div class="dialog-header">
      <div class="header-content">
        <i class="pi pi-money-bill header-icon"></i>
        <h4>Storico contributi del <span class="font-bold">{{ richiesta?.enteEsecutore?.label | uppercase }}</span> per l'anno</h4>
        <div class="code-badge" style="background-color: #f5f5f5; padding: 0.25rem 0.5rem; border-radius: 4px; margin-left: 1rem;">
          <span class="code-value" style="font-weight: bold; color: #3a6e75;">{{ richiesta?.anno }}</span>
        </div>
      </div>
      <button
        pButton
        pRipple
        icon="pi pi-times"
        class="p-button-rounded p-button-text close-btn"
        (click)="hide()">
      </button>
    </div>

    <div class="dialog-content">
      <div class="storico-container">
        <div class="loading-container" *ngIf="isLoading">
          <ng-lottie
            class="loader-lottie"
            [options]="lottieConfig"
          ></ng-lottie>
        </div>

        <div *ngIf="!isLoading && eventi.length === 0" class="empty-state">
          <i class="pi pi-info-circle" style="font-size: 3rem; color: #6c757d;"></i>
          <p>Nessuno storico contributi disponibile</p>
        </div>

        <div *ngIf="!isLoading && eventi.length > 0" class="timeline-container">
          <p-timeline [value]="eventi" align="alternate">
            <ng-template pTemplate="marker" let-evento>
              <div class="custom-marker">
                <i class="pi pi-euro" style="font-size: 1.2rem; color: #4f97c4;"></i>
              </div>
            </ng-template>
            <ng-template pTemplate="content" let-evento>
              <p-card class="contributo-card">
                <div class="contributo-header">
                  <div class="contributo-importo">
                    <span class="label">Importo</span>
                    <span class="valore">{{ formatImporto(evento.valore) }}</span>
                  </div>
                  <div class="contributo-data">
                    <i class="pi pi-calendar" style="margin-right: 0.5rem; color: #6c757d;"></i>
                    <span>{{ formatDate(evento.dataInizio) }}</span>
                  </div>
                </div>
                <p-divider *ngIf="evento.note"></p-divider>
                <div class="contributo-note" *ngIf="evento.note">
                  <span class="note-label">
                    <i class="pi pi-comment" style="margin-right: 0.5rem;"></i>
                    Note:
                  </span>
                  <p class="note-text">{{ evento.note }}</p>
                </div>
              </p-card>
            </ng-template>
          </p-timeline>
        </div>
      </div>
    </div>

    <div class="dialog-footer">
      <button
        pButton
        pRipple
        label="Chiudi"
        icon="pi pi-times"
        class="p-button-outlined p-button-secondary"
        (click)="hide()">
      </button>
    </div>
  </div>
</p-dialog>
